import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// import { UserModel } from '../../_models/user.model';
import { environment } from '../../../environments/environment';
// import { AuthModel } from '../../_models/auth.model';

const API_USERS_URL = `${environment.apiUrl}/users`;

@Injectable({
  providedIn: 'root',
})
export class ProcessService {
  constructor(private http: HttpClient) { }
  setProcessStep(data) {
    return this.http.put<any>(`${environment.apiUrl}/t/users/process`, data);
  }
  getUserDetails() {
    return this.http.get<any>(`${environment.apiUrl}/t/users/me`);
  }
  setUserDetails(data) {
    return this.http.put<any>(`${environment.apiUrl}/t/users/me`, data);
  }

  getMaritalDetails() {
    return this.http.get<any>(`${environment.apiUrl}/t/users/marital`);
  }
  setMaritalDetails(data) {
    return this.http.put<any>(`${environment.apiUrl}/t/users/marital`, data);
  }

  getChildrenDetails() {
    return this.http.get<any>(`${environment.apiUrl}/t/users/children`);
  }
  setChildrenDetails(data) {
    return this.http.put<any>(`${environment.apiUrl}/t/users/children`, data);
  }

  getPetDetails() {
    return this.http.get<any>(`${environment.apiUrl}/t/users/pets`);
  }
  setPetDetails(data) {
    return this.http.put<any>(`${environment.apiUrl}/t/users/pets`, data);
  }
  getExecutorDetails() {
    return this.http.get<any>(`${environment.apiUrl}/t/users/executors`);
  }
  setExecutorDetails(data) {
    return this.http.put<any>(`${environment.apiUrl}/t/users/executors`, data);
  }
  getBackupExecutorDetails() {
    return this.http.get<any>(`${environment.apiUrl}/t/users/backupexecutors`);
  }
  setBackupExecutorDetails(data) {
    return this.http.put<any>(`${environment.apiUrl}/t/users/backupexecutors`, data);
  }
  getEstateDetails() {
    return this.http.get<any>(`${environment.apiUrl}/t/users/estate`);
  }
  setEstateDetails(data) {
    return this.http.put<any>(`${environment.apiUrl}/t/users/estate`, data);
  }
  getEstateDivisionDetails() {
    return this.http.get<any>(`${environment.apiUrl}/t/users/estate`);
  }
  setEstateDivisionDetails(data) {
    return this.http.put<any>(`${environment.apiUrl}/t/users/estatedivision`, data);
  }
  getCharityList() {
    return this.http.get<any>(`${environment.apiUrl}/t/charities/all`);
  }
  getCharityDetails() {
    return this.http.get<any>(`${environment.apiUrl}/t/users/charities`);
  }
  setCharityDetails(data) {
    return this.http.put<any>(`${environment.apiUrl}/t/users/charities`, data);
  }
  getBackupEstateDetails() {
    return this.http.get<any>(`${environment.apiUrl}/t/users/backupestate`);
  }
  setBackupEstateDetails(data) {
    return this.http.put<any>(`${environment.apiUrl}/t/users/backupestate`, data);
  }
  getGiftDetails() {
    return this.http.get<any>(`${environment.apiUrl}/t/users/gifts`);
  }
  setGiftDetails(data) {
    return this.http.put<any>(`${environment.apiUrl}/t/users/gifts`, data);
  }
  getFuneralDetails() {
    return this.http.get<any>(`${environment.apiUrl}/t/users/funeral`);
  }
  setFuneralDetails(data) {
    return this.http.put<any>(`${environment.apiUrl}/t/users/funeral`, data);
  }

  getWillDownloadUrl() {
    return this.http.get<any>(`${environment.apiUrl}/t/users/downloadwill`);
  }

  createPaySession() {
    return this.http.post<any>(`${environment.apiUrl}/t/checkout/session`, {});
  }
  // createPayIntent(data) {
  //   return this.http.post<any>(`${environment.apiUrl}/t/checkout/s`, data);
  // }

  createPayment(data) {
    return this.http.post<any>(`${environment.apiUrl}/t/checkout/p`, data);
  }
  selectPlan(data) {
    return this.http.post<any>(`${environment.apiUrl}/t/checkout/s`, data);
  }
  send_legal_email_prepaid(data) {
    return this.http.post<any>(`${environment.apiUrl}/t/checkout/e`, data);
  }

  sendInvite(data) {
    return this.http.post<any>(`${environment.apiUrl}/t/m/invite`, data);
  }

  // // public methods
  // login(email: string, password: string): Observable<any> {
  //   return this.http.post<AuthModel>(`${environment.apiUrl}/t/auth/login`,   { email, password });
  // }

  // // CREATE =>  POST: add a new user to the server
  // createUser(user: UserModel): Observable<UserModel> {
  //   return this.http.post<UserModel>(API_USERS_URL, user);
  // }

  // // Your server should check email => If email exists send link to the user and return true | If email doesn't exist return false
  // forgotPassword(email: string): Observable<boolean> {
  //   return this.http.post<boolean>(`${API_USERS_URL}/forgot-password`, {
  //     email,
  //   });
  // }

  // getUserByToken(token): Observable<{success:boolean, data:UserModel}> {
  //   const httpHeaders = new HttpHeaders({
  //     Authorization: `Bearer ${token}`,
  //   });
  //   return this.http.get<{success:boolean, data:UserModel}>(`${environment.apiUrl}/t/users/me`, {
  //     headers: httpHeaders,
  //   });
  // }
}
